<template>
  <div>
    <ts-page-title
      :title="$t('trainerProfile.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('trainerProfile.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button
          type="primary"
          @click="$router.push({ name: 'trainer-profile-create' })"
        >
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end">
          <a-input
            v-model="search"
            v-tooltip="$t('trainerProfile.search')"
            :placeholder="$t('trainerProfile.search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>
              <img
                class="tw-rounded tw-h-8 tw-w-7"
                v-lazy="{
                  src: photo(record),
                  error:
                    record.sex == 'Male'
                      ? require('@/assets/staff-default-man.png')
                      : require('@/assets/staff-default-women.png'),
                  loading: require('@/assets/Rolling-1s-200px.svg'),
                  preLoad: 1.3,
                  attempt: 1,
                }"
              />
            </td>
            <td class="tw-whitespace-nowrap">{{ record.full_name_kh }}</td>
            <td class="tw-whitespace-nowrap">{{ record.full_name_en }}</td>
            <td class="tw-whitespace-nowrap tw-text-center">
              {{ record.sex }}
            </td>
            <td class="tw-whitespace-nowrap">{{ record.register_date }}</td>
            <td class="tw-whitespace-nowrap">{{ record.phone }}</td>
            <td class="tw-text-center tw-items-center tw-whitespace-nowrap">
              <span class="tw-text-green-500" v-if="record.is_external">
                <a-icon type="check-circle" class="tw-text-lg" />
              </span>
              <span v-else class="tw-text-red-500">
                <a-icon type="close-circle" class="tw-text-lg" />
              </span>
            </td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>

          <div slot="expand" slot-scope="prop">
            <table class="tw-w-11/12 tw-mx-auto detail">
              <thead>
                <tr class="tw-uppercase tw-bg-gray-200 tw-h-8 tw-text-white">
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("trainerProfile.skillLevel") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("trainerProfile.availableInYear") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("trainerProfile.expireDate") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="tw-border-b-2"
                  v-for="(detail, index) in prop.record.level_skills"
                  :key="index"
                >
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.level_skill_name }} | {{ detail.skill_name_en }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.available_in_year }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.expire_date }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
export default {
  name: "trainerIndex",
  components: {},
  data() {
    return {
      file: require("../../../assets/staff-default-man.png"),
      loading: false,
    };
  },
  computed: {
    ...mapState("academic/trainerProfile", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.trainerProfile.search;
      },
      set(newValue) {
        this.$store.commit("academic/trainerProfile/SET_SEARCH", newValue);
        this.$store.commit("academic/trainerProfile/RESET_CURRENT_PAGE");
      },
    },
    columns() {
      return [
        {
          name: this.$t("trainerProfile.photo"),
          style: "width: 50px;text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("trainerProfile.fullNameKh"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("trainerProfile.fullNameEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("trainerProfile.sex"),
          style: "width: 100px;white-space: nowrap;text-align:center;",
        },
        {
          name: this.$t("trainerProfile.registerDate"),
          style: "width: 200px;white-space: nowrap;",
        },
        {
          name: this.$t("trainerProfile.phone"),
          style: "width: 200px;white-space: nowrap;",
        },
        {
          name: this.$t("trainerProfile.isExternal"),
          style: "width: 100px;text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;",
        },
      ];
    },
  },
  methods: {
    photo(record) {
      if (record.photo) {
        return record.photo;
      }

      return record.sex == "Male"
        ? require("@/assets/staff-default-man.png")
        : require("@/assets/staff-default-women.png");
    },
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/trainerProfile/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    edit(record) {
      this.$store.commit("academic/trainerProfile/SET_EDIT_DATA", record);
      this.$router.push({
        name: "trainer-profile-edit",
        params: { id: record.candidate_id },
      });
    },
    clearEdit() {
      this.$store.commit("academic/trainerProfile/SET_EDIT_DATA", {});
      this.fetchData();
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("academic/trainerProfile/destroy", record.trainer_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/trainerProfile/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
